export default "__VITE_ASSET__BqmWvfWI__"